import { styled } from '@linaria/react'

export const TrailerPlayerSC = styled.div`
  width: 100%;
  height: 100%;
`
